import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { FDPaper, FDStack } from '@facet-wealth/design';

const useStyles = buildUseStyles('CardContainer', ((theme) => ({
  fullWidthLayout: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2),
    maxWidth: 500,
    width: '100%',
    padding: theme.spacing(0, 2),
  },
})));

export const CardContainer = ({ children, fullWidthLayout }) => {
  const classes = useStyles();
  if (fullWidthLayout) {
    return <Box className={classes.fullWidthLayout}>{children}</Box>;
  }
  return (
    <FDPaper padding={2} appearance="flat" color="subtle">
      <FDStack direction="column">
        {children}
      </FDStack>
    </FDPaper>
  );
};

CardContainer.propTypes = {
  fullWidthLayout: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
